import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { CommonServiceService } from '../../../component/common/common-service.service';
import { CreatePatientComponent } from '../create-patient/create-patient.component';
import { ViewPatientComponent } from '../view-patient/view-patient.component';
import { ViewPatientProfileComponent } from '../view-patient-profile/view-patient-profile.component';
import { MyDatePickerModule  } from 'mydatepicker';
import { LoaderComponentPatientData } from '../../../shared/component/loader-data/loader.component';
import { EditPatientComponent } from '../edit-patient/edit-patient.component';
import { VitalSignComponent } from '../view-patient-profile/vital-sign/vital-sign.component';
import { AppointmentComponent } from '../view-patient-profile/appointment/appointment.component';
import { ClinicalNotesComponent } from '../view-patient-profile/clinical-notes/clinical-notes.component';
import { TreatmentPlanComponent } from '../view-patient-profile/treatment-plan/treatment-plan.component'; 
import { FilterTextPipe } from '../pipe/filter-text.pipe'
import { PatientDialogBox } from '../../../shared/component/dialog-box/dialog.component';
import { AddPatientAppointmentComponent} from '../add-appointment/add-appointment.component';
@NgModule({
  imports: [
    CommonModule ,
    FormsModule,
    MyDatePickerModule,
    RouterModule.forChild([
            {path : 'createpatient', component : CreatePatientComponent},
            {path : 'viewpatient', component : ViewPatientComponent}, 
            {path : 'patientprofile/:id', component : ViewPatientProfileComponent},
            {path : 'patientprofile/:id/:appid', component : ViewPatientProfileComponent},
            {path : 'patientprofile', component : ViewPatientProfileComponent}
             
          ])
  ],
  declarations: [
    CreatePatientComponent,
    ViewPatientComponent,
    ViewPatientProfileComponent,
    FilterTextPipe,
    LoaderComponentPatientData,
    EditPatientComponent,
    PatientDialogBox, VitalSignComponent, AppointmentComponent, ClinicalNotesComponent, TreatmentPlanComponent, AddPatientAppointmentComponent
  ],
  providers : [CommonServiceService],
  schemas: [ NO_ERRORS_SCHEMA ],
  exports: [RouterModule]
})

export class PatientRouteModule { }



// WEBPACK FOOTER //
// ./src/app/section/patient/patient-route/patient-route.module.ts